import React, { useState } from "react";
import { MainContainer, MainHeading, ProductsHeader, SearchRow, ActionsRow } from "./styles";
import { Form, Input, Modal, message } from "antd";
import UsersListing from "./UsersListing";
import UserForm from "./UserForm";
import AntButton from "../../uiKits/Button";
import { useInviteUserMutation } from "../../api/authApi";
const { Search } = Input;

const UsersComponent = () => {
  const [searchInput, setSearchInput] = useState("");
  const [searchFilter, setSearchFilter] = useState("");
  const [isUserModalOpen, setIsUserModalOpen] = useState(false);
  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
  const [inviteForm] = Form.useForm();
  const [inviteUser, { isLoading: isInviting }] = useInviteUserMutation();

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setSearchFilter(searchInput.trim());
    }, 500);

    return () => clearTimeout(timer);
  }, [searchInput]);

  const handleSearch = (event) => {
    setSearchInput(event.target.value);
  };

  return (
    <MainContainer>
      <MainHeading>Users</MainHeading>

      <ProductsHeader>
        <SearchRow>
          <Search
            placeholder="Search users"
            value={searchInput}
            onSearch={(value) => setSearchInput(value)}
            onChange={handleSearch}
          />
        </SearchRow>
        <ActionsRow>
          <AntButton onClick={() => setIsInviteModalOpen(true)}>Invite User</AntButton>
          <AntButton onClick={() => setIsUserModalOpen(true)}>Add User</AntButton>
        </ActionsRow>
      </ProductsHeader>
      <UsersListing searchFilter={searchFilter} />

      <Modal
        title="Add User"
        open={isUserModalOpen}
        footer={null}
        onCancel={() => setIsUserModalOpen(false)}
        destroyOnClose
        width={720}
      >
        <UserForm onUserAdded={() => setIsUserModalOpen(false)} embedded />
      </Modal>
      <Modal
        title="Invite Special User"
        open={isInviteModalOpen}
        footer={null}
        onCancel={() => setIsInviteModalOpen(false)}
        destroyOnClose
      >
        <Form
          form={inviteForm}
          layout="vertical"
          onFinish={async ({ email }) => {
            try {
              await inviteUser(email).unwrap();
              message.success("Invitation email sent");
              inviteForm.resetFields();
              setIsInviteModalOpen(false);
            } catch (err) {
              message.error(err?.data?.message || "Failed to send invitation");
            }
          }}
        >
          <Form.Item
            label="Email"
            name="email"
            rules={[{ required: true, type: "email", message: "Enter a valid email" }]}
          >
            <Input placeholder="invitee@example.com" />
          </Form.Item>
          <AntButton htmlType="submit" loading={isInviting}>
            Send invitation
          </AntButton>
        </Form>
      </Modal>
    </MainContainer>
  );
};

export default UsersComponent;
